"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGrowthSourceNames = exports.ToDoStatus = void 0;
var ToDoStatus;
(function (ToDoStatus) {
    ToDoStatus["ToDo"] = "ToDo";
    ToDoStatus["InProgress"] = "InProgress";
    ToDoStatus["Completed"] = "Completed";
})(ToDoStatus = exports.ToDoStatus || (exports.ToDoStatus = {}));
;
var IGrowthSourceNames;
(function (IGrowthSourceNames) {
    IGrowthSourceNames["Partner"] = "Partner";
    IGrowthSourceNames["Referral"] = "Referral";
    IGrowthSourceNames["Collaborator"] = "Collaborator";
    IGrowthSourceNames["Team"] = "Team";
    IGrowthSourceNames["Invoice"] = "Invoice";
    IGrowthSourceNames["Content"] = "Content";
    IGrowthSourceNames["Enterprise"] = "Enterprise";
})(IGrowthSourceNames = exports.IGrowthSourceNames || (exports.IGrowthSourceNames = {}));
//# sourceMappingURL=activity.js.map